import RouteMap from "./RouteMap";
import { formatArrival, bareDuration, pickupLabel } from "./utils";

// Chrome 60-safe — no ?. / flex gap / backdrop-filter
const FooterEta = function (props) {
  var s = props.s;
  var pickup = props.pickup;
  var routes = props.routes;
  var error = props.error;
  var single = props.single;
  var onMapLoad = props.onMapLoad;
  var showMap = props.showMap !== false;
  var pickLabel = function (r) {
    if (!r) return "";
    return !showMap && r.fullLabel ? r.fullLabel : r.label;
  };
  var r0 = routes[0];
  // map-mode cards, sized against the strip beside the map
  var mc = s.nmCards(routes.length, 1, s.mapPanelBox.footer);

  // Full-width strip — everything reads across in one line of blocks, since
  // a footer has width to spare and almost no height.
  if (!showMap) {
    var badge = (
      <span style={s.nmBadge}>
        <span style={s.nmDot} /> Live Traffic ETA
      </span>
    );

    // pickup shown once for the whole list, not repeated per card

    var from = (
      <span style={s.nmFrom}>
        <span style={s.nmFromLabel}>From</span>
        <span style={s.nmFromValue}>{pickupLabel(pickup) || "—"}</span>
      </span>
    );

    if (error) {
      return (
        <div style={s.nmRoot}>
          <div style={s.nmGlow} />
          <div style={s.nmGlowLow} />
          <div
            style={Object.assign({}, s.nmBody, {
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            })}
          >
            {badge}
            <div style={s.nmError}>{error}</div>
          </div>
        </div>
      );
    }

    if (single) {
      var arrival = formatArrival(r0 && r0.durationSecs);
      return (
        <div style={s.nmRoot}>
          <div style={s.nmGlow} />
          <div style={s.nmGlowLow} />

          <div
            style={Object.assign({}, s.nmBody, {
              flexDirection: "row",
              alignItems: "center",
            })}
          >
            <div style={{ flex: 1.15, minWidth: 0 }}>
              {badge}
              <div
                style={Object.assign({}, s.nmJourney, {
                  marginTop: s.nmTile.marginRight,
                })}
              >
                <div style={s.nmRail}>
                  <span style={s.nmRailDot} />
                  <span style={s.nmRailLine} />
                  <span style={s.nmRailPin} />
                </div>
                <div style={s.nmStops}>
                  <div style={s.nmStopValue}>{pickupLabel(pickup) || "—"}</div>
                  <div style={s.nmStopValue}>{pickLabel(r0)}</div>
                </div>
              </div>
            </div>

            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={s.nmHeroLabel}>Estimated time</div>
              <div style={s.nmHeroRow}>
                <span style={s.nmHeroValue}>
                  {(r0 && bareDuration(r0.duration)) || "--"}
                </span>
              </div>
            </div>

            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={s.nmStats}>
                <div style={s.nmTile}>
                  <div style={s.nmTileLabel}>Distance</div>
                  <div style={s.nmTileValue}>{(r0 && r0.distance) || "--"}</div>
                </div>
                {arrival ? (
                  <div style={Object.assign({}, s.nmTile, { marginRight: 0 })}>
                    <div style={s.nmTileLabel}>Arrives</div>
                    <div style={s.nmTileValue}>{arrival}</div>
                  </div>
                ) : null}
              </div>
              {r0 && r0.traffic ? (
                <span
                  style={Object.assign({}, s.nmPill, {
                    color: r0.traffic.color,
                    marginTop: s.nmTile.marginRight,
                  })}
                >
                  <span style={s.nmPillDot} />
                  {r0.traffic.label}
                </span>
              ) : null}
            </div>
          </div>
        </div>
      );
    }

    // one row, cards side by side across the strip
    var c = s.nmCards(routes.length, 1);
    return (
      <div style={s.nmRoot}>
        <div style={s.nmGlow} />
        <div style={s.nmGlowLow} />
        <div style={s.nmTopBar}>
          {badge}
          {s.nmFromInline ? from : null}
        </div>
        {s.nmFromInline ? null : <div style={s.nmFromRow}>{from}</div>}
        <div
          style={Object.assign({}, s.nmList, s.nmListRow, {
            flexDirection: "row",
          })}
        >
          {routes.map(function (r) {
            return (
              <div
                key={r.index}
                style={Object.assign(
                  {},
                  c.card,
                  c.tint(r.traffic && (r.traffic.fill || r.traffic.color)),
                )}
              >
                <span
                  style={Object.assign({}, c.accent, {
                    background: r.traffic ? c.railTint : r.color,
                  })}
                />
                <div style={c.label}>{r.label || pickLabel(r)}</div>
                <div style={c.row}>
                  <span style={c.time}>{bareDuration(r.duration)}</span>
                  <span style={c.dist}>{r.distance}</span>
                </div>
                <div style={c.foot}>
                  {r.traffic ? (
                    <span
                      style={Object.assign({}, c.pill, {
                        color: r.traffic.color,
                      })}
                    >
                      <span style={c.pillDot} />
                      {r.traffic.label}
                    </span>
                  ) : null}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <div style={Object.assign({}, s.wrapper, { flexDirection: "row" })}>
      <div style={s.footerPanel}>
        {error ? (
          <div style={s.content}>
            <div style={s.error}>{error}</div>
          </div>
        ) : single ? (
          <span>
            <span
              style={Object.assign({}, s.badge, {
                fontSize: parseFloat(s.badge.fontSize) * 1.8 + "px",
              })}
            >
              <span
                style={Object.assign({}, s.dotLive, {
                  width: parseFloat(s.dotLive.width) * 1.8 + "px",
                  height: parseFloat(s.dotLive.height) * 1.8 + "px",
                  marginRight: parseFloat(s.dotLive.marginRight) * 1.8 + "px",
                })}
              />{" "}
              Live Traffic ETA
            </span>

            <div style={s.footerFromTo}>
              <span>
                <span style={s.footerFromLabel}>To: </span>
                <span style={s.footerFromToVal}>{pickLabel(r0)}</span>
              </span>
            </div>

            <div style={s.footerHero}>
              <span style={s.footerHeroKm}>{(r0 && r0.distance) || "--"}</span>
              <span style={s.footerHeroMins}>
                {r0 && r0.duration ? "in " + r0.duration + "." : ""}
              </span>
            </div>

            {r0 && r0.traffic ? (
              <span style={s.footerTrafficPill}>{r0.traffic.label}</span>
            ) : null}
          </span>
        ) : (
          <span>
            <div style={s.header}>
              <span style={s.badge}>
                <span style={s.dotLive} /> Live Traffic ETA
              </span>
            </div>
            <div style={s.footerItems}>
              {routes.map(function (r) {
                return (
                  <div
                    key={r.index}
                    style={Object.assign(
                      {},
                      mc.card,
                      mc.tint(r.traffic && (r.traffic.fill || r.traffic.color)),
                    )}
                  >
                    <span
                      style={Object.assign({}, mc.accent, {
                        background: r.traffic ? mc.railTint : r.color,
                      })}
                    />
                    <div style={mc.label}>{pickLabel(r)}</div>
                    <div style={mc.row}>
                      <span style={mc.time}>{bareDuration(r.duration)}</span>
                      <span style={mc.dist}>{r.distance}</span>
                    </div>
                    <div style={mc.foot}>
                      {r.traffic ? (
                        <span
                          style={Object.assign({}, mc.pill, {
                            color: r.traffic.color,
                          })}
                        >
                          <span style={mc.pillDot} />
                          {r.traffic.label}
                        </span>
                      ) : null}
                      <span style={mc.routeChip}>
                        A &rarr; {String.fromCharCode(66 + r.index)}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </span>
        )}
      </div>

      {showMap ? (
        <div style={s.footerMapSide}>
          <RouteMap
            s={s}
            pickup={pickup}
            routes={routes}
            single={single}
            onMapLoad={onMapLoad}
          />
        </div>
      ) : null}
    </div>
  );
};

export default FooterEta;
